import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DISTRIBUTION_COST_GET } from 'api/query-keys';
import type { TGetDistributionCostRes } from 'api/swagger';
import type { IDistributionCostFilter } from 'shared/stores/use-distribution-cost-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IDistributionCostFilter;
}

export const useGetDistributionCost = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IDistributionCostFilter>(qs, filters);

  return useQuery({
    queryKey: [DISTRIBUTION_COST_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetDistributionCostRes>(`/v1/statistics/distribution-cost?${qs.toString()}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
